import { IndustryPage } from './IndustryPage'
import { industriesData } from '@/data/industries'

export default function Healthcare() {
  return <IndustryPage industry={industriesData.healthcare!} />
}
